import React, {Component} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {FaIcon} from "../FaIcon";
import {MultiSelect} from "../selects/MultiSelect";
import {Spinner} from "../Spinner";
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import { withTranslation } from 'react-i18next';

class LabelsFilterModalComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedLabels: this.props.selectedLabels,
            labels: null,
        };

        this.handleLabelsMultiselectChange = this.handleLabelsMultiselectChange.bind(this);
        this.handleApplyFilter = this.handleApplyFilter.bind(this);
    }

    componentDidMount() {
        new APIClient(API_URL + 'agency/labels').call('GET')
            .then((response) => {
                if (response.status === 'OK') {
                    this.setState({
                        labels: response.result
                    });
                } else {
                    alert(response.error_message);
                }
            });
    }

    handleApplyFilter(event) {
        event.preventDefault();
        this.props.onApplyFilter(this.state.selectedLabels);
        this.props.onClose();
    }

    handleLabelsMultiselectChange(selectedLabels) {
        this.setState({selectedLabels: selectedLabels});
    }

    renderLabelsMultiselect() {
        if (this.state.labels !== null) {
            if(this.state.labels.length > 0) {
                return <MultiSelect
                    items={this.state.labels}
                    selectedItemIds={this.props.selectedLabels}
                    itemDataMap={(item) => {
                        return {name: item, id: item}
                    }}
                    onChange={this.handleLabelsMultiselectChange}
                />
            } else {
                const { t } = this.props;
                return <p>{t('dashboard.no_labels_yet')}</p>
            }
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    render() {
        const { t } = this.props;
        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.onClose}>
                <form>
                    <ModalHeader>
                        <FaIcon iconName="tags"/>
                        {t('dashboard.filter_by_labels')}
                    </ModalHeader>
                    <ModalBody>
                        <div className="modal-section">
                            <div className="form-row">
                                {this.renderLabelsMultiselect()}
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <input type="submit" value={t('dashboard.filter')} className="btn -submit"
                               onClick={this.handleApplyFilter}/>
                    </ModalFooter>
                </form>
            </Modal>
        );
    }
}

export const LabelsFilterModal = withTranslation()(LabelsFilterModalComponent);

